import { ChartTooltipContent } from "../ui/chart";

/**
 * ChartTooltipのコンテンツ生成ロジック
 * パーセンテージ表示用のカスタムロジックを含む
 */
export const createTooltipContent = ({ payload, active, label }: any) => {
  if (!active || !payload) return null;

  const customPayload = payload.map((item: any) => ({
    ...item,
    value: Number(item.value) >= 1 ? (item.value === "100" ? "99" : item.value) : "<1",
  }));

  return <ChartTooltipContent className="percentage" payload={customPayload} label={label} active={active} />;
};
